import swal from 'sweetalert';
import Api from './Api';
const useDelete = (url = ``) => {
  swal({
    text: "Are you sure that you want to remove this record?",
    icon: "warning",
    dangerMode: true,
    buttons: true
  }).then(willDelete => {
    if (willDelete) {
      Api.get(url)
        .then(function (response) {
          if (response.data.resultCode === "00") {
            swal("", "saved", "success");
          } else {
            swal("", response.data.description, "error");
          }

        })
        .catch(function (error) {
          // handle error
          swal("", "Failed", "error");
        })
        .then(function () {
          // always executed
        })
    }
  });
};

export default useDelete;